<template>
    <div v-if="currentUser" class="container-fluid mb-5 w-100 g-0">
        <div class="d-flex flex-row" style="background: #eeeeee;">
            <AdminNavbar />
            <div class="p-0 w-100 content" style="background: #fff;">
                <div class="catalog-menu-headings position-relative mt-2">
                    <span class="p-3">
                        <i class="bi bi-sliders"></i>
                        &nbsp;Настройки сайта
                    </span>
                    <div class="p-3 settings-form">
                        <div class="form-check mt-3">
                            <input id="easterMode" class="form-check-input" type="checkbox"
                                v-model="settings.easterMode" :disabled="isSaving"
                                @change="onToggle('easter')">
                            <label class="form-check-label" for="easterMode">
                                Включить режим Пасхи
                            </label>
                        </div>

                        <div class="form-check mt-3">
                            <input id="newYearMode" class="form-check-input" type="checkbox"
                                v-model="settings.newYearMode" :disabled="isSaving"
                                @change="onToggle('newYear')">
                            <label class="form-check-label" for="newYearMode">
                                Включить режим Нового года
                            </label>
                        </div>

                        <button type="button" class="btn btn-success mt-4" :disabled="isSaving" @click="saveSettings">
                            <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status"
                                aria-hidden="true"></span>
                            {{ isSaving ? "Сохраняем..." : "СОХРАНИТЬ" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        {{ $router.push('/') }}
    </div>
</template>

<script>
import AdminNavbar from '../AdminNavbar';
import http from "../../../http-common";
import { useToast } from "vue-toastification";

export default {
    name: "AdminSiteSettings",
    components: {
        AdminNavbar: AdminNavbar,
    },
    setup() {
        const toast = useToast();

        return {
            toast,
        };
    },
    data() {
        return {
            isSaving: false,
            settings: {
                easterMode: false,
                newYearMode: false,
            },
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    methods: {
        onToggle(mode) {
            if (mode === "easter" && this.settings.easterMode) {
                this.settings.newYearMode = false;
            }
            if (mode === "newYear" && this.settings.newYearMode) {
                this.settings.easterMode = false;
            }
        },
        getSettings() {
            http
                .get("/adminSiteSettings")
                .then(response => {
                    this.settings = {
                        easterMode: Boolean(response.data && response.data.easterMode),
                        newYearMode: Boolean(response.data && response.data.newYearMode),
                    };
                })
                .catch(e => {
                    console.log(e);
                    this.toast.error("Не удалось загрузить настройки сайта");
                });
        },
        async saveSettings() {
            if (this.isSaving) {
                return;
            }

            this.isSaving = true;
            try {
                const response = await http.post("/adminSiteSettings", this.settings);
                this.settings = {
                    easterMode: Boolean(response.data && response.data.easterMode),
                    newYearMode: Boolean(response.data && response.data.newYearMode),
                };
                this.toast.success("Настройки сайта сохранены");
            } catch (e) {
                console.log(e);
                this.toast.error("Не удалось сохранить настройки сайта");
            } finally {
                this.isSaving = false;
            }
        },
    },
    mounted() {
        this.getSettings();
    }
};
</script>

<style scoped>
.catalog-menu-headings {
    font-family: 'Segoe UI', Tahoma, Verdana, sans-serif;
    background: #fff;
    color: #434343 !important;
    font-size: 18pt;
    font-weight: bold;
}

.settings-form {
    max-width: 620px;
    font-size: 12pt;
    font-weight: normal;
}
</style>
